<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <div style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
          <el-breadcrumb-item>網頁設計</el-breadcrumb-item>
          <el-breadcrumb-item>首頁</el-breadcrumb-item>
          <el-breadcrumb-item>Banner</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋名稱" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input> -->

    </template>
    <template slot="right">
      <el-button @click="$router.push({ name: 'createHomeBanner' })" style="margin-right: 20px;">新增Banner</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="預覽" width="90px">
          <template slot-scope="scope">
            <img
              :src="scope.row.Tw.ImageURLX1"
              class="w-100"/>
          </template>
        </el-table-column>
        <el-table-column label="權重" width="50px">
          <template slot-scope="scope">
            <p style="text-align: right;">{{scope.row.Tw.Weigh}}</p>
          </template>
        </el-table-column>
        <el-table-column label="置頂" width="50px">
          <template slot-scope="scope">
            <p v-if="scope.row.Tw.IsTop" class="deployed" style="text-align: center;">✓</p>
            <p v-else class="draft"></p>
          </template>
        </el-table-column>
        <el-table-column label="狀態" width="70px">
          <template slot-scope="scope">
            <p v-if="scope.row.IsActive" class="deployed">發佈</p>
            <p v-else class="draft">下架</p>
          </template>
        </el-table-column>
        <el-table-column label="最後更新時間" width="170px">
          <template slot-scope="scope">
            {{scope.row.UpdatedAt | moment}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              @click="$router.push({ name: 'updateHomeBanner', params: { id: scope.row.ID }})">編輯</el-button>

            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
// mixin
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
export default {
  mixins: [MixinLanguages, MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null
    }
  },
  computed: {},
  methods: {
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.$store.state.homeBanner.list
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        if (o.NameTw && o.NameTw.includes(this.keyword)) return true
        if (o.NameCn && o.NameCn.includes(this.keyword)) return true
        if (o.NameEn && o.NameEn.includes(this.keyword)) return true
        if (o.NameJp && o.NameJp.includes(this.keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.$store.state.homeBanner.list.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 Banner ?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.homeBanner.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.homeBanner.list.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.$store.state.homeBanner.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    }
  },
  created () {
    const initTableData = () => {
      this.searchedObjs = this.$store.state.homeBanner.list
      this.tableData = this.searchedObjs.slice(0, 20)
    }
    // query...
    this.$services.homeBanner.getAll(this).then(res => {
      res.data.result = res.data.result.sort((o1, o2) => {
        if (o1.IsActive !== o2.IsActive) return o2.IsActive - o1.IsActive
        if (o1.Tw.IsTop !== o2.Tw.IsTop) return o2.Tw.IsTop - o1.Tw.IsTop
        return o2.Weigh - o1.Weigh
      })
      console.log(`res.data.result=`, res.data.result)
      this.$store.state.homeBanner.list = res.data.result
      initTableData()
    }).catch(this.$handleServiceError)
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
